import { useQuery } from "react-query";

import type { OtPurpose, Steps } from "@jti/fe-common";

import { CasPurposesApi } from "../../../services";

const fetchConsentFields = async (consent: Steps): Promise<OtPurpose[]> => {
  const api = CasPurposesApi.init();
  return api.getPurposesByStep(consent);
};

export const useConsentFields = (consent?: Steps) => {
  const {
    data: consentFields = [],
    error,
    isLoading,
  } = useQuery({
    queryKey: ["consentFields", consent],
    queryFn: () => fetchConsentFields(consent!),
    staleTime: 5000,
    retry: 1,
    enabled: !!consent,
  });

  return { consentFields, error, isLoading };
};
